import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from "react-router-dom";
import useApi from "../../hooks/useApi";
import {webInfo} from "../../utils/webInfo";
import TableSkeleton from "../../Loader/Loader";
import {Card} from "primereact/card";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Paginator} from "primereact/paginator";
import usePost from "../../hooks/usePost";
import useDelete from "../../hooks/useDelete";
import {catchError} from "../../utils/helper";
import ErrorPresentor from "../../ErrorPresentor/ErrorPresentor";
import moment from "moment/moment";
import {Skeleton} from "primereact/skeleton";
import {InputSwitch} from "primereact/inputswitch";
import {Badge} from "primereact/badge";
import EmptyData from "../../components/EmptyData";

const NoticeboardList = () => {
    const navigate = useNavigate();
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const {get, loading, error} = useApi<any>();
    const [notices,setNotices] = useState([]);
    const url = `${webInfo.baseUrl}/api/admin/notice-board?page=${page}&per_page=${perPage}`
    const [visibleConfirmation, setVisibleConfirmation] = useState<boolean>(false)
    const [update,setUpdate] = useState<boolean>(false)
    const [selectedId, setSelectedId] = useState(null)
    const {post,loading:ploading} = usePost()
    const {remove,loading:rloading} = useDelete()
    const onPageChange = (event: any) => {
        setPage(event.page + 1);
    }


    useEffect(() => {
        const fetchNoticeboard = async () => {
            try {
                const res: any = await get(url);
                setNotices(res.data.data);
                setTotal(res.data.total);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchNoticeboard();
        // eslint-disable-next-line
    }, [page, perPage,update]);


    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">Notice Board</h4>
            <div>
                <Button onClick={()=>navigate('/create-notice')} label="Create New" icon="pi pi-plus" iconPos="right" />
            </div>
        </div>
    )


    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Remove notice confirmation</span>
        </div>
    );
    const footerContent = ()=>{
        const deleteInnovation = async ()=>{
            const deleteUrl = `${webInfo.baseUrl}/api/admin/notice-board/${selectedId}`;
            try {
                const res:any = await remove(deleteUrl)
                if (res.success){
                    setUpdate(!update);
                    setVisibleConfirmation(false)
                }
            }catch (e) {
                catchError(e)
            }
        }
        return <div className="flex justify-content-end align-items-center">
            <Button label="cancel" icon="pi pi-times" onClick={() => setVisibleConfirmation(false)} autoFocus />
            <Button disabled={rloading} label="Delete" severity={'danger'} className="ml-2" icon="pi pi-delete" onClick={deleteInnovation} autoFocus />
        </div>
    };

    const actionTemplate = (rowData:any) => (
        <div className="flex gap-2 justify-content-center">
            <Button
                icon="pi pi-pencil"
                label="Edit"
                className="p-button-sm"
                onClick={() => navigate(`/notice-details/${rowData.id}`)}
            />
            <Button
                icon="pi pi-trash"
                label="Remove"
                className="p-button-sm p-button-danger"
                onClick={() => {
                    setVisibleConfirmation(true)
                    setSelectedId(rowData.id)
                }}
            />
        </div>
    );
    if (error) {
        return <ErrorPresentor error={error}/>
    }

    const imageTemplate = (rowData:any) => (
        <img
            src={`${webInfo.baseUrl}/${rowData.image}`}
            alt={'blogs'}
            style={{
                width: "50px",
                height: "50px",
                objectFit: "cover",
                borderRadius: "6px",
            }}
        />
    );
    const titleAuthorTemplate = (rowData:any) => {
        return <div>
            <small>{moment(rowData.created_at).format("LL")}</small>
            <h5 className="m-0">
                <Link className="text-gray-900 underline" to={`/notice-details/${rowData.id}`}>{rowData.title}</Link>
            </h5>
        </div>
    }

    const publishStatus = (rowData:any) => {
        const statusUpdateUrl = `${webInfo.baseUrl}/api/admin/notice-board/${rowData.id}/publish-status`
        const updateStatus = async (rowData: any) => {
            const payload = {
                status: Number(rowData.status)===1 ? 0 : 1,
            }
            try {
                const res:any = await post(statusUpdateUrl,true,payload)
                if (res.success){
                    setUpdate(!update);
                }
            }catch (e) {
                catchError(e)
            }
        }

        if (ploading){
            return <Skeleton width={"4rem"} height={"2.5rem"}></Skeleton>
        }
        return <div className="flex gap-2 justify-content-start">
            <InputSwitch checked={Number(rowData?.status) === 1} onChange={()=>updateStatus(rowData)} />
        </div>
    }

    const documentTemplate = (rowData:any) => {
        return <div className="flex">
            <img
                alt="Default"
                src={`/pdf.jpg`} height="50"/>
            <div className="ml-2">
                <p className="mb-2">{rowData?.file.split("/").at(-1)}</p>
                <div className="flex align-items-center">
                    <p className="m-0">00.00 KB</p>
                    <Badge className="ml-2" value="Default"></Badge>
                </div>
            </div>
        </div>
    }

    const dataTable = <div>
        <Dialog visible={visibleConfirmation} modal header={headerElement} footer={footerContent} style={{ width: '30rem' }} onHide={() => {if (!visibleConfirmation) return; setVisibleConfirmation(false); }}>
            <p className='m-0'>Are you sure, deleting this item? Once you delete it won't be able to view again</p>
        </Dialog>

        <div>
            {
                (notices?.length>0 && !loading) ? <div>
                    <DataTable
                        emptyMessage="No Notice found"
                        value={notices}
                        rows={5}
                        stripedRows
                    >
                        <Column
                            header="Image"
                            body={imageTemplate}
                            style={{ width: "100px", textAlign: "center" }}
                        />
                        <Column body={titleAuthorTemplate} header="Title" sortable />
                        <Column
                            header="Document"
                            body={documentTemplate}
                            style={{ width: "100px", textAlign: "center" }}
                        />
                        <Column body={publishStatus} header="Publish Status" sortable />
                        <Column
                            header="Actions"
                            body={actionTemplate}
                            style={{ width: "140px", textAlign: "center" }}
                        />
                    </DataTable>
                    <Paginator
                        first={(page - 1) * perPage}
                        rows={perPage}
                        totalRecords={total}
                        rowsPerPageOptions={[10, 20, 30]}
                        onPageChange={onPageChange}
                    />
                </div> : <EmptyData/>
            }
        </div>
    </div>

    return (
        <Card header={header}>
            {loading ? <TableSkeleton/> : dataTable}
        </Card>
    );
};

export default NoticeboardList;